import React from "react";
import ItemsList from "./ItemsList";
import useCartState from "src/core/checkout/hooks/useCartState";
import useErrors from "../../hooks/useErrors";
import get from "lodash/get";

function CartItems(props) {
  const [cartState] = useCartState();
  const cart = cartState.data;

  const items = cart ? cart.getItems() : [];

  const [errors] = useErrors(null, itemErrorFilter);

  return <ItemsList items={items} errors={errors} {...props} />;
}

function itemErrorFilter(error) {
  return Boolean(get(error, "extra_info.item.uuid", null));
}

export default CartItems;
